import type { ToastItem, ToastType } from './ToastContext';

interface ToastContainerProps {
  toasts: ToastItem[];
  onDismiss: (id: number) => void;
}

// Literal Tailwind class map (same purge-safe idiom as `statusColors` in
// PurchaseOrders.tsx) with dark: variants on every surface (TNT-005).
const ToastStyles: Record<ToastType, string> = {
  success: 'bg-green-100 dark:bg-green-900/40 text-green-800 dark:text-green-200 border-green-500 dark:border-green-400',
  error: 'bg-red-100 dark:bg-red-900/40 text-red-800 dark:text-red-200 border-red-500 dark:border-red-400',
  info: 'bg-blue-100 dark:bg-blue-900/40 text-blue-800 dark:text-blue-200 border-blue-500 dark:border-blue-400',
};

const ICONS: Record<ToastType, string> = {
  success: '✓',
  error: '✕',
  info: 'ℹ️',
};

const MAX_VISIBLE_TOASTS = 3;

export function ToastContainer({ toasts, onDismiss }: ToastContainerProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-4 right-4 left-4 sm:left-auto sm:right-6 sm:bottom-6 z-[60] flex flex-col gap-2 w-auto sm:w-96"
    >
      {toasts.slice(0, MAX_VISIBLE_TOASTS).map((t) => (
        <div
          key={t.id}
          className={`${ToastStyles[t.type]} rounded-lg border-l-4 shadow-xl p-4 pr-10 relative`}
        >
          <span aria-hidden="true">{ICONS[t.type]}</span>{' '}
          <span>{t.message}</span>
          <button
            type="button"
            aria-label="Cerrar notificación"
            onClick={() => onDismiss(t.id)}
            className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-lg text-base leading-none hover:bg-black/10 dark:hover:bg-white/10 transition-colors"
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}